import { makeApi } from "@zodios/core";
import { z } from "zod";

import { personAccessDtoSchema } from "@/types/backoffice/dto/person/person-access-dto.ts";

export const backofficeRootApi = makeApi([
  {
    method: "get",
    path: "/access",
    response: z.array(personAccessDtoSchema),
    alias: "findOperatorAccess",
  },
  {
    method: "get",
    path: "/access-company",
    response: z.boolean(),
    alias: "isOperatorHasExternalEndCallService",
  },
]);
